/* eslint-disable no-nested-ternary, prettier/prettier */

const str2Int = (str, def) => {
	const value = parseInt(str, 10);
	return Number.isNaN(value) ? def : value;
}

/**
 * Parses Number
 */
const parseNumber = (value, def) => (
	typeof value === "string" ? str2Int(value, def) :
	typeof value === "number" ? value :
	def
);

export default parseNumber;